<template>
	<div v-if="date || user">
		<!-- Single line mode: date by firstName lastName -->
		<div v-if="singleLine">
			<span v-if="date">{{ formattedDate }}</span>
			<span v-if="date && user"> by </span>
			<span v-if="user">{{ user.firstName }} {{ user.lastName }}</span>
		</div>
		<!-- Multi-line mode: date on first line, name on second line -->
		<template v-else>
			<div v-if="date">{{ formattedDate }}</div>
			<div v-if="user">
				{{ user.firstName }} {{ user.lastName }}
			</div>
		</template>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useDateTimeHelper } from "@/composables/dateTimeHelper"

interface User {
	firstName?: string
	lastName?: string
}

interface Props {
	date?: Date | string | null
	user?: User | null
	singleLine?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	singleLine: false,
})

const formattedDate = computed(() => {
	if (!props.date) return ""
	return useDateTimeHelper(props.date).toLocalTimeZoneDateStandardFormat()
})
</script>
